export const DeviceCreateSceneTranslation = {
  fi: {
    DeviceCreateScene: {
      title: 'Lisää älylääkevaunu',
    },
  },
};
